import React, { useState } from "react";
import "./Google.css";

function Google() {
  const whatsappLink = "https://wa.me/5511988833017";

  const itens = [
    "Expandir mapa geográfico na busca pelos clientes.",
    "Presença digital atrativa e sólida para seus clientes.",
    "Contato direto com o cliente.",
    "Desempenho e divulgação do seu negócio.",
    "Credibilidade e confiança para seus clientes.",
    "Ferramenta criativa e moderna",
  ];

  const [ativo, setAtivo] = useState(null);

  const handleCardClick = (index) => {
    setAtivo(index === ativo ? null : index);
  };

  return (
    <section className="google-section" id="google">
      <h2 className="google-titulo">
        Perfil no Google Meu Negócio — Para que serve?
      </h2>

      <div className="google-content">
        <div className="google-cards">
          {itens.map((texto, index) => (
            <div
              className={`google-card slide-up delay-${index + 1} ${
                ativo === index ? "active" : ""
              }`}
              key={index}
              onClick={() => handleCardClick(index)}
            >
              <p>{texto}</p>
              <span className="linha"></span>
            </div>
          ))}
        </div>
      </div>

      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="google-btn"
      >
        Fale com um especialista
      </a>
    </section>
  );
}

export default Google;
